import { z } from "zod";

const versionValues = ["Latest", "ReleaseCandidate"] as const;

export const versionSchema = z.enum(versionValues);
